import { replaceWhiteLabelTitle } from 'library-@/utils/replaceWhiteLabelTitle';

export function setTitle(page, locale = 'en', whiteLabel) {
    const title = {
        userSetting: {
            cn: '账户中心 - 智慧芽',
            en: 'Account Center - PatSnap',
            tw: '賬戶中心 - 智慧芽',
            jp: 'アカウント - PatSnap',
            de: 'Account Center - PatSnap'
        },
        saveQuery: {
            cn: '已保存语句 - 智慧芽',
            en: 'Saved Searches - PatSnap',
            tw: '已保存語句 - 智慧芽',
            jp: '保存した検索式 - PatSnap',
            de: 'Saved Searches - PatSnap'
        },
        nameGrouping: {
            cn: '申请人分组 - 智慧芽',
            en: 'Assignee Grouping - PatSnap',
            tw: '申請人分組 - 智慧芽',
            jp: '出願者グループ - PatSnap',
            de: 'Assignee Grouping - PatSnap'
        },
        fields: {
            cn: '自定义字段 - 智慧芽',
            en: 'Custom Fields - PatSnap',
            tw: '自定義字段 - 智慧芽',
            jp: 'カスタムフィールド - PatSnap',
            de: 'Custom Fields - PatSnap'
        }
    };
    let _title = replaceWhiteLabelTitle({
        title: title[page][locale],
        isWhiteLabel: whiteLabel
    });
    document.title = _title;
}

export function setPageTitle(page, locale = 'en', whiteLabel) {
    const title = {
        texttour: {
            cn: '特色功能  - 智慧芽',
            en: 'Feature Overview - PatSnap',
            tw: '特色功能  - 智慧芽',
            jp: '機能と特徴  - PatSnap',
            de: 'Feature Overview - PatSnap'
        },
        terms: {
            cn: '服务条款 - 智慧芽',
            en: 'Terms of Service - PatSnap',
            tw: '服務條款 - 智慧芽',
            jp: '利用規約 - PatSnap',
            de: 'Terms of Service - PatSnap'
        },
        privacy: {
            cn: '隐私政策 - 智慧芽',
            en: 'Privacy Policy - PatSnap',
            tw: '隱私政策 - 智慧芽',
            jp: 'プライバシーポリシー - PatSnap',
            de: 'Privacy Policy - PatSnap'
        },
        status: {
            cn: '数据范围 - 智慧芽',
            en: 'Data Coverage - PatSnap',
            tw: '數據範圍 - 智慧芽',
            jp: 'データ範囲 - PatSnap',
            de: 'Data Coverage - PatSnap'
        },
        releaseLog: {
            cn: '更新日志  - 智慧芽',
            en: 'Release Log - PatSnap',
            tw: '更新日誌  - 智慧芽',
            jp: 'ログの更新  - PatSnap',
            de: 'Release Log - PatSnap'
        },
        searchHelper: {
            cn: '搜索帮助  - 智慧芽',
            en: 'Search Helper - PatSnap',
            tw: '搜索幫助  - 智慧芽',
            jp: '検索ヘルプ  - PatSnap',
            de: 'Suche-Hilfer - PatSnap'
        },
        quota: {
            cn: '服务限制 - 智慧芽',
            en: 'Service Usage Limits - PatSnap',
            tw: '服務配額 - 智慧芽',
            jp: 'サービスクォータ - PatSnap',
            de: 'Servicepensum - PatSnap'
        },
        countryList: {
            cn: '智慧芽——具有人性化的专利检索分析工具',
            en: 'PatSnap Patent Search and Analysis Platform',
            tw: '智慧芽——具有人性化的專利檢索分析工具',
            jp: 'PatSnap —— もっともヒューマナイズされた特許検索分析ツール',
            de: 'PatSnap——Plattform dafür, Patent zu suchen und zu analysieren'
        },
        onBoarding: {
            cn: '调查问卷  - 智慧芽',
            en: 'Profiling - PatSnap',
            tw: '調查問卷  - 智慧芽',
            jp: 'アンケート  - PatSnap',
            de: 'Profiling - PatSnap'
        },
        packageList: {
            cn: '专利数据库套餐版本  - 智慧芽',
            en: 'Packages of Patsnap Analytics  - PatSnap',
            tw: '专利数据库套餐版本  - 智慧芽',
            jp: '专利数据库套餐版本  - 智慧芽',
            de: '专利数据库套餐版本  - 智慧芽',
        },
        unsubscribe: {
            cn: '邮件提醒退订确认',
            en: 'Unsubscribe Email Alert Confirmation',
            tw: '郵件提醒退訂確認',
            jp: 'メールによるキャンセル確認の通知',
            de: 'Unsubscribe Email Alert Confirmation'
        }
    };
    let _title = replaceWhiteLabelTitle({
        title: title[page][locale],
        isWhiteLabel: whiteLabel
    });
    document.title = _title;
}
